(function () {
  if (!document.body || !document.body.classList.contains('template-product')) return;
  var path = (location.pathname || '').toLowerCase();
  var isZx = /\/products\/zx-/.test(path);
  var BADGE_CLASS = 'luggex-lifetime-warranty-badge';

  function badgeSrc() {
    var existing = document.querySelector('.' + BADGE_CLASS + ' img');
    if (existing && existing.src) return existing.src;
    var link = document.querySelector('link[href*="luggex-lifetime-warranty-badge"]');
    if (link) return link.href;
    var cdnImg = document.querySelector('img[src*="cdn/shop"]');
    if (cdnImg && cdnImg.src) {
      var mImg = cdnImg.src.match(/(\/cdn\/shop\/t\/\d+\/)/);
      if (mImg) return mImg[1] + 'assets/luggex-lifetime-warranty-badge.svg';
    }
    var any = document.querySelector('script[src*="/cdn/shop/t/"]');
    var m = any && any.src && any.src.match(/(\/cdn\/shop\/t\/\d+\/)/);
    var base = m ? m[1] : '/cdn/shop/t/96/';
    return base + 'assets/luggex-lifetime-warranty-badge.svg';
  }

  function ensureBadgeCss() {
    var s = document.getElementById('luggex-lifetime-warranty-badge-css-v2');
    if (!s) {
      s = document.createElement('style');
      s.id = 'luggex-lifetime-warranty-badge-css-v2';
      document.head.appendChild(s);
    }
    s.textContent = '.' + BADGE_CLASS + '{position:absolute;top:20px;left:20px;z-index:10;width:100px!important;max-width:100px!important;pointer-events:none;line-height:0}' +
      '.' + BADGE_CLASS + ' img{display:block;width:100%;height:auto}' +
      '@media (max-width:767px){.' + BADGE_CLASS + '{top:12px;left:12px;width:60px!important;max-width:60px!important}}' +
      '.product__thumbnails .' + BADGE_CLASS + ',.product__thumbnails-list .' + BADGE_CLASS + ',.product__thumbnail .' + BADGE_CLASS + ',media-dots .' + BADGE_CLASS + '{display:none!important}';
    document.querySelectorAll('.' + BADGE_CLASS).forEach(function (b) {
      b.style.removeProperty('width');
      b.style.removeProperty('max-width');
    });
  }

  function placeBadge() {
    if (!isZx) return;
    document.querySelectorAll('.product__thumbnails .luggex-lifetime-warranty-badge, .product__thumbnails-list .luggex-lifetime-warranty-badge, .product__thumbnail .luggex-lifetime-warranty-badge, media-dots .luggex-lifetime-warranty-badge').forEach(function (b) { b.remove(); });
    document.querySelectorAll('media-gallery.starapps .luggex-lifetime-warranty-badge').forEach(function (b) { b.remove(); });
    ensureBadgeCss();
    var hosts = document.querySelectorAll('media-gallery:not(.starapps) .product__media-container > div.relative.w-full.h-full');
    hosts.forEach(function (host) {
      var gallery = host.closest('media-gallery') || host;
      gallery.querySelectorAll('.product__media .' + BADGE_CLASS).forEach(function (b) { b.remove(); });
      if (host.querySelector(':scope > .' + BADGE_CLASS)) return;
      var wrap = document.createElement('div');
      wrap.className = BADGE_CLASS;
      wrap.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img');
      img.src = badgeSrc();
      img.alt = '';
      img.width = 100;
      img.height = 100;
      img.decoding = 'async';
      wrap.appendChild(img);
      host.insertBefore(wrap, host.firstChild);
    });
  }

  function lockShow(el) {
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('hidden');
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('opacity', '1', 'important');
  }
  function lockHide(el) {
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
  }
  function fixGallery() {
    document.querySelectorAll('.product__thumbnails .luggex-lifetime-warranty-badge, .product__thumbnails-list .luggex-lifetime-warranty-badge, .product__thumbnail .luggex-lifetime-warranty-badge, media-dots .luggex-lifetime-warranty-badge').forEach(function (b) { b.remove(); });
    document.querySelectorAll('media-gallery.starapps .luggex-lifetime-warranty-badge').forEach(function (b) { b.remove(); });
    document.querySelectorAll('media-gallery:not(.starapps)').forEach(function (g) {
      lockShow(g);
      g.querySelectorAll('slider-element').forEach(lockShow);
      var host = g.closest('.product__gallery-container');
      if (host) host.style.setProperty('height', 'auto', 'important');
    });
    document.querySelectorAll('media-gallery.starapps, [id$="-starapps"]').forEach(lockHide);
    placeBadge();
  }

  function boot() {
    fixGallery();
    var n = 0;
    var t = setInterval(function () {
      fixGallery();
      if (++n >= 60) clearInterval(t);
    }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', fixGallery);
})();
